import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {DialogContentText} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import LinkDiscordButton from "./LinkDiscordButton";
import Dialog from "@material-ui/core/Dialog";

const LinkDiscord = (props) => {
	const blurb = props.blurb || <p>Due to increased traffic on the server, you must link your Discord account to use the map (<a href='https://www.a2pogo.com/n/discord_linking_required.html'>more information</a>). Ann Arbor area locals only, please!</p>;

	return (<Dialog open={true}>
			<DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
			<DialogContent>
				<DialogContentText>{blurb}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose} color="primary" autoFocus>
					Cancel
				</Button>
				<LinkDiscordButton />
			</DialogActions>
		</Dialog>);
};

LinkDiscord.propTypes = {
	title: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
};


export default LinkDiscord;